export enum socialMediaEnum {
  WEBSITE = 'WEBSITE',
  LINKEDIN = 'LINKEDIN',
  FACEBOOK = 'FACEBOOK',
  INSTAGRAM = 'INSTAGRAM',
  TWITTER = 'TWITTER',
  THREADS = 'THREADS',
  TELEGRAM = 'TELEGRAM',
  DISCORD = 'DISCORD',
  MAIL = 'MAIL',
  PINTEREST = 'PINTEREST',
}
